module.exports = __webpack_public_path__ + "static/media/sense.28252a53.png";